// extracted by mini-css-extract-plugin
export const layout = "Layout-module--layout--5AHmX";
export const layoutMain = "Layout-module--layoutMain--3rt4p";